// Shared Apify utilities for client-side code

export interface ApifyActor {
  id: string;
  name: string;
  username: string;
  title?: string;
  description?: string;
  pictureUrl?: string;
  stats?: {
    totalRuns?: number;
    totalUsers?: number;
  };
}

export interface ApifyRun {
  id: string;
  actId: string;
  status: string;
  startedAt: string;
  finishedAt?: string;
  defaultDatasetId?: string;
}

export interface ApifySchema {
  properties?: Record<string, {
    type?: string;
    title?: string;
    description?: string;
    default?: unknown;
    enum?: unknown[];
  }>;
  required?: string[];
}

/**
 * Normalize actor ID to username~actorname format
 * Apify Store API returns internal IDs, but /acts/ endpoint needs username~actorname format
 */
export function normalizeActorId(
  actorId: string,
  actor?: { username?: string; name?: string }
): string {
  if (!actorId) return actorId;

  // If already in username~name or username/name format, normalize to tilde
  if (actorId.includes("~") || actorId.includes("/")) {
    return actorId.replace(/\//g, "~");
  }

  // If we have actor object with username and name, construct it
  if (actor?.username && actor?.name) {
    return `${actor.username}~${actor.name}`;
  }

  // Fallback: return as-is
  return actorId;
}

/**
 * Extract default values from an Apify actor schema
 */
export function getSchemaDefaults(schema: ApifySchema | null): Record<string, unknown> {
  if (!schema?.properties) return {};

  const defaults: Record<string, unknown> = {};
  for (const [key, prop] of Object.entries(schema.properties)) {
    if (prop.default !== undefined) {
      defaults[key] = prop.default;
    }
  }
  return defaults;
}


